import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import { TextField } from "@mui/material";
import { es } from "date-fns/locale";

export default function DateTimePicker({
  field, // <-- Formik Field props
  form, // <-- Formik Form props
  label,
  maxDate,
  minDate,
  views = ["year", "month", "day", "hours", "minutes"],
  disabled,
}) {
  // Usa el valor de Formik o null
  const value = field?.value ? new Date(field.value) : null;

  const handleChange = (date) => {
    form.setFieldValue(field.name, date);
    form.setFieldTouched(field.name, true, true);
  };

  return (
    <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
      <MobileDateTimePicker
        label={label}
        inputFormat="dd/MM/yyyy HH:mm"
        value={value}
        onChange={handleChange}
        maxDate={maxDate}
        minDate={minDate}
        views={views}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            name={field.name}
            size="small"
            fullWidth
            error={Boolean(form.touched[field.name] && form.errors[field.name])}
            helperText={form.touched[field.name] && form.errors[field.name]}
          />
        )}
      />
    </LocalizationProvider>
  );
}
